exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}", ""]);

